export default __webpack_public_path__ + "static/media/etherbulls.474239c8.png";